import { useContext, useEffect, useState } from 'react'
import { Button } from '@telus-uds/components-web'
import staticContents from '../../utils/staticContent'
import { articleConsumer } from '../../provider/ArticleProvider'
import { setShowMoreAnalyticsEvent } from '@/blogBuilder/analytics/setShowMoreAnalyticsEvent'

import type { Language } from '@/siteBuilder/locale'

type Props = {
  lang: Language
  size: number
  setSize: (size: number | ((_size: number) => number)) => Promise<Response[]>
  countIncrease: number
}

const ShowMoreButton = ({ countIncrease, size, setSize, lang }: Props) => {
  const { allArticles, articles, selectedCategory, count, setCount } = useContext(articleConsumer)
  const [showMoreClickCount, setShowMoreClickCount] = useState(1)

  useEffect(() => {
    setShowMoreClickCount(1)
  }, [selectedCategory])

  if (!lang) return null

  if (allArticles.length === articles.length) return null

  const handleOnClick = () => {
    setCount(count + countIncrease)
    void setSize(size + 1)

    setShowMoreClickCount(showMoreClickCount + 1)
    setShowMoreAnalyticsEvent(selectedCategory, showMoreClickCount)
  }

  return (
    <Button testID="bb-show-more-button" variant={{ priority: 'high' }} onPress={() => handleOnClick()}>
      {staticContents.ARTICLES.SHOW_MORE[lang]}
    </Button>
  )
}

export default ShowMoreButton
